import React from "react";

import { AutoScrollTopComponent } from "../components/auto-scroll-top.component";
import { LegalAdviserProfileComponent } from "./components/legal-adviser-profile/legal-adviser-profile.component";
import { ContactContainerComponent } from "../contact/contact-container.component";
import { FaqContainerComponent } from "../faq/faq-container.component";
import { ImageGalleryContainerComponent } from "../image-gallery/image-gallery.container.component";
import { AboutUsComponent } from "./components/about-us/about-us.component";
import { CoverComponent } from "./components/cover-section/cover-section.component";
import { ClientContainerComponent } from "./components/client-container.component";
import { WhyChooseUsContainerComponent } from "./components/why-choose-us/why-choose-us.container.component";
import { ServiceContainerComponent } from "./components/services/service-container.component";
import { CertificationsContainerComponent } from "./components/certifications/certifications.container.component";
import { WhyOutsourceComponent } from "./components/why-outsource/why-outsource.component";
import { OutsourcingBenifitsComponent } from "./components/outsourcing-benefits/outsourcing-benefits.component";

interface IHomeContainerComponentProps {}

export const HomeContainer: React.FC<IHomeContainerComponentProps> = (
    props: IHomeContainerComponentProps
) => {
    return (
        <>
            <AutoScrollTopComponent />
            <CoverComponent />
            <ClientContainerComponent />
            <AboutUsComponent />
            <ServiceContainerComponent />
            <WhyOutsourceComponent />
            <OutsourcingBenifitsComponent />
            <WhyChooseUsContainerComponent />
            <CertificationsContainerComponent />
            <LegalAdviserProfileComponent />
            <ImageGalleryContainerComponent />
            <FaqContainerComponent />
            <ContactContainerComponent />
        </>
    );
};
